import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { multiSelectSlice } from 'Slices/multiSelectSlice'
import SliceConfig from 'Configs/fields/utm_medium.json'
import ExcludeValaues from 'Configs/data/excludedValues.json'
import { ContractSource } from 'Types/contractTypes'
import { CandidateContractsApi } from 'Services/contracts/candidatesContracts'

const contractSource = ContractSource.candidates

const transformValues = function (selectedValues) {
  return selectedValues.map((value) => (value === 'None Selected' ? '' : value))
}

const extraReducer = (builder) => {
  builder.addMatcher(
    CandidateContractsApi.endpoints.getUTMMedium.matchFulfilled,
    (state, action) => {
      state.values = action.payload.data.map((item) => item?.utm_medium)
        .filter(val => !!val && !ExcludeValaues.includes(val))
    }
  )
}

export const UTMMediumSlice = multiSelectSlice(
  'utm_medium',
  'setUTMMedium',
  SliceConfig.values,
  SliceConfig.meta,
  transformValues,
  null,
  extraReducer
)

export const selectUTMMedium = createSelector(
  ({ onDemandFilter: { prospectProfile } }: RootState) => prospectProfile.UTMMedium.selectedValues,
  ({ onDemandFilter: { prospectProfile } }: RootState) => prospectProfile.UTMMedium.values,
  (
    selectedValues: string[],
    values: string[]
  ): {
    selectedValues: string[]
    values: string[]
    audienceTypes: string[]
    label
  } => {
    return {
      selectedValues,
      values,
      audienceTypes: SliceConfig.source[contractSource].audience_types,
      label: SliceConfig.meta.label,
    }
  }
)

export const { setUTMMedium } = UTMMediumSlice.actions

export default UTMMediumSlice.reducer